import styled from "styled-components";
import { colors, screenSizes, typography } from "@streeteasy/design-system";
import ButtonAction, {
  buttonActionThemes
} from "@streeteasy/design-system/button-action";

export const Wrapper = styled.div`
  margin: 9px 0 0 0;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    margin: 16px 0 0 0;
  }
`;

export const InfoBox = styled(typography.Caption)`
  color: ${colors.TEXT_SECONDARY};
  display: flex;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    justify-content: flex-end;
  }
`;

export const ActionButton = styled(ButtonAction).attrs({
  type: "button",
  theme: buttonActionThemes.SECONDARY
})`
  align-items: center;
  background: none;
  border: none;
  color: ${colors.BRAND};
  display: flex;
  height: auto;
  margin: -1px 0 0 9px;
  min-width: auto;
  padding: 0;

  &:focus {
    background: none;
    border: none;
  }
`;
